import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Tenabeltemplate extends Component {
 
  render() {
    const course =[
      {
        title: "Introduction to Tenable",
        content: [
        "Overview of Tenable and its products",
        "Introduction to the Tenable.io platform",
        "Understanding the Tenable architecture and data model",
        "Introduction to Vulnerability Management",
        "Setting up a Tenable environment"
        ]
        },
        {
        title: "Tenable Basic Configuration",
        content: [
        "Installing and configuring Tenable products",
        "Managing users, roles, and permissions",
        "Creating and managing policies and scans",
        "Understanding asset management",
        "Creating and managing reports"
        ]
        },
        {
        title: "Advanced Tenable Configuration",
        content: [
        "Understanding compliance management",
        "Customizing policies and scans",
        "Integrating with ticketing systems",
        "Managing and resolving vulnerabilities",
        "Automating Tenable workflows"
        ]
        },
        {
        title: "Tenable.io Administration",
        content: [
        "Managing users and permissions",
        "Configuring security and access controls",
        "Data management and data quality",
        "Creating and managing workflows, approvals, and process builder",
        "Managing customizations, including apps, objects, fields, and layouts"
        ]
        },
        {
        title: "Tenable.io Vulnerability Management",
        content: [
        "Introduction to Vulnerability Management",
        "Scanning and assessing vulnerabilities",
        "Understanding risk management",
        "Remediating vulnerabilities",
        "Integrating Tenable with other security tools"
        ]
        },
        {
        title: "Tenable.io Compliance Management",
        content: [
        "Introduction to Compliance Management",
        "Configuring and running audits",
        "Understanding compliance policies and standards",
        "Automating compliance workflows",
        "Integrating with other compliance tools"
        ]
        },
        {
        title: "Tenable.io Container Security",
        content: [
        "Introduction to Container Security",
        "Securing container environments",
        "Assessing container vulnerabilities",
        "Understanding container risk management",
        "Integrating Tenable with container orchestration tools"
        ]
        },
        {
        title: "Tenable.sc Administration",
        content: [
        "Managing users and permissions",
        "Configuring security and access controls",
        "Data management and data quality",
        "Creating and managing workflows, approvals, and process builder",
        "Managing customizations, including apps, objects, fields, and layouts"
        ]
        },
        {
        title: "Tenable.sc Vulnerability Management",
        content: [
        "Introduction to Vulnerability Management",
        "Scanning and assessing vulnerabilities",
        "Understanding risk management",
        "Remediating vulnerabilities",
        "Integrating Tenable with other security tools"
        ]
        },
        {
        title: "Tenable.sc Compliance Management",
        content: [
        "Introduction to Compliance Management",
        "Configuring and running audits",
        "Understanding compliance policies and standards",
        "Automating compliance workflows",
        "Integrating with other compliance tools"
        ]
        },
        {
        title: "Tenable.sc Log Management",
        content: [
        "Introduction to Log Management",
        "Configuring log sources",
        "Creating and managing dashboards",
        "Creating and managing reports",
        "Integrating with other log management tools"
        ]
        },
        {
        title: "Tenable Advanced Topics",
        content: [
        "Tenable scripting and automation",
        "Using Tenable API",
        "Customizing Tenable dashboards and reports",
        "Tenable Plugins and Nessus updates",
        "Enterprise security with Tenable"
        ]
        }
    ]

    const faqData = [
      {
        question: 'What is Tenable Training?',
        answer:
          'Tenable Training is a specialized program designed to equip individuals with the skills and knowledge required to effectively utilize Tenable\'s cybersecurity solutions for vulnerability management and threat detection',
      },
      {
        question: 'Why is Tenable Training important?',
        answer:
          'Tenable Training is essential for professionals seeking to enhance their cybersecurity skills, enabling them to effectively identify and mitigate security risks within their organizations',
      },
      {
        question: 'Who can benefit from Tenable Training?',
        answer:
          'Tenable Training at the best training centre is suitable for cybersecurity professionals, IT administrators, network engineers, and anyone responsible for managing and securing IT infrastructure',
      },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'A person with Tenable skills can pursue a variety of career opportunities such as Security Analyst, Vulnerability Management Specialist, Security Operations Center (SOC) Analyst, and Cybersecurity Engineer',
      },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Embark on a transformative journey into Tenable at the Best Training Centre. Our comprehensive Tenable training program welcomes individuals from diverse backgrounds, regardless of prior experience in cybersecurity and vulnerability management. Whether you're an aspiring cybersecurity professional, IT administrator, or network engineer looking to master Tenable's suite of security solutions, our courses cater to learners at every proficiency level. With a focus on practical application and hands-on learning, our expert instructors guide you through essential Tenable concepts, including vulnerability assessment, risk management, compliance, and threat detection. At the Best Training Centre, we prioritize accessibility and inclusivity, ensuring that all learners have the opportunity to excel in harnessing the power of Tenable. Join us and unlock your potential in Tenable with the best training centre"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:` learnsoft.org has earned a reputation as a leading platform for ${this.props.title} training in ${this.props.location}. Their programs are designed to provide a comprehensive understanding of ${this.props.title} modules, making them a top choice for HR professionals.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:`${this.props.title}, staying informed about the latest trends, tools, and best practices is essential. learnsoft.org recognizes this need and provides a dedicated section for ${this.props.title} reviews.`
      },
  ]
 
     return(
      <>
         
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the ever-evolving landscape of cybersecurity, Tenable emerges as a vanguard, providing organizations with the means to navigate the intricate realm of cyber risk. As a dedicated cybersecurity company, Tenable is committed to equipping organizations with solutions that enable them to not only identify but also effectively manage cyber risks. At the forefront of their offerings is Tenable.io, a cloud-based platform that revolutionizes vulnerability identification and remediation prioritization."/> */}
           
          <NewMainsec rating='4.2' students={"284"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the ever-evolving landscape of cybersecurity, Tenable emerges as a vanguard, providing organizations with the means to navigate the intricate realm of cyber risk. As a dedicated cybersecurity company, Tenable is committed to equipping organizations with solutions that enable them to not only identify but also effectively manage cyber risks. At the forefront of their offerings is Tenable.io, a cloud-based platform that revolutionizes vulnerability identification and remediation prioritization."/>

            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		<Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`Tenable ${this.props.location1} is an essential field with an increasing demand for cybersecurity professionals with Tenable skills. At Learnsoft.org, we offer top-notch Tenable training courses in ${this.props.location} to help individuals enhance their skills and gain a comprehensive understanding of Tenable principles and practices. Our experienced trainers use a hands-on approach, incorporating real-world scenarios and practical exercises to provide a well-rounded education. Whether you're new to Tenable or looking to expand your skillset, Learnsoft.org's Tenable ${this.props.location1} is the perfect choice to take your career to the next level. Contact us today to learn more about our courses and start your Tenable journey.`} 
    title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our Tenable course covers a wide range of topics, including vulnerability management, security automation, and compliance management. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in Tenable. By the end of the course, you will be able to implement Tenable practices in your own projects."}/>
           </section>
           <Batchtime title={this.props.title} fees="25,999" offer="18,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
 <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>   
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou="Jira Admin" coupath="jira-admin" cou1='Qualys' coupath1='qualys' cou2='BigFix' coupath2='bigfix' cou3='DevSecOps' coupath3='devsecops'
           cou4='Azure Security' coupath4='azure-security' cou5='Pega' coupath5='pega' cou6='AwsSysOps' coupath6='aws-sysops' cou7='Okta' coupath7='okta' cou8='Python' coupath8='python' 
           cou9='Java' coupath9='java'  cou10='Go Lang' coupath10='go'/>
       
        
      </>
    );
  }
}
